import { OrderEvent } from "@app/domain";
import { AsyncState } from "@app/shared/hooks/useAsync";
import { useEventHistory } from "./useEventHistory";

/**
 * The most recent event on the order — powers Home's "Last Event" card for
 * non-Ondemand orders. Built on top of `useEventHistory` (which already
 * reads the order's events straight from Redux) rather than a separate
 * fetch, mirroring the legacy `state.order.events[events.length - 1]`
 * derivation.
 *
 * Skips entirely while `enabled` is false — Ondemand orders show a driver
 * card instead and never need this data.
 */
export function useLastEvent(trackCode: string, enabled: boolean): AsyncState<OrderEvent | null> {
  const events = useEventHistory(trackCode, enabled);

  if (!enabled) return { status: "success", data: null, error: undefined };
  if (events.status !== "success") return events as AsyncState<OrderEvent | null>;

  const list = events.data ?? [];
  return { status: "success", data: list.length > 0 ? list[list.length - 1] : null, error: undefined };
}
